import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";

import appStore from "./AppStore";

const PageTracking = () => {
    if ( appStore.isAnalyticsEnabled() ) {
        const location = useLocation();

        useEffect(() => {
            ReactGA.send("pageview");
        }, [location]);
    }
};

export default PageTracking;